(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sohi-cart-drawer"]) return;
  try {
    
  (function () {
    "use strict";
    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';
    var lastFocused = null;
    var lockedScrollY = 0;
    function drawer() { return document.querySelector("[data-cart-drawer]"); }
    function lockScroll() {
      var root = document.documentElement;
      if (root.hasAttribute("data-scroll-lock")) return;
      lockedScrollY = window.pageYOffset || root.scrollTop || 0;
      document.body.style.top = -lockedScrollY + "px";
      root.setAttribute("data-scroll-lock", "");
    }
    function filtersDrawerOpen() { return !!document.querySelector("[data-filters-drawer][data-open]"); }
    function unlockScroll() {
      var root = document.documentElement;
      if (!root.hasAttribute("data-scroll-lock") || filtersDrawerOpen()) return;
      root.removeAttribute("data-scroll-lock");
      document.body.style.top = "";
      var previous = root.style.scrollBehavior;
      root.style.scrollBehavior = "auto";
      window.scrollTo(0, lockedScrollY);
      root.style.scrollBehavior = previous;
    }
    function open() {
      var element = drawer();
      if (!element) return;
      lastFocused = document.activeElement;
      lockScroll();
      element.setAttribute("data-open", "");
      var closeButton = element.querySelector(".drawer__close");
      if (closeButton) closeButton.focus();
    }
    function close() {
      var element = drawer();
      if (!element) return;
      element.removeAttribute("data-open");
      unlockScroll();
      if (lastFocused && document.contains(lastFocused)) lastFocused.focus();
      lastFocused = null;
    }
    function trap(event, element) {
      var items = Array.prototype.filter.call(element.querySelectorAll(FOCUSABLE), function (node) { return node.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
    document.addEventListener("click", function (event) {
      if (event.target.closest("[data-cart-open]")) { event.preventDefault(); open(); return; }
      var closer = event.target.closest("[data-drawer-close]");
      if (closer && closer.closest("[data-cart-drawer]")) close();
    });
    document.addEventListener("keydown", function (event) {
      var element = drawer();
      if (!element || !element.hasAttribute("data-open")) return;
      if (event.key === "Escape") close();
      else if (event.key === "Tab") trap(event, element);
    });
    document.addEventListener("cart:open", open);
  })();

  } catch(e) { console.error(e); }
})();
})();
